import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { SelectBaseComponent } from 'src/app/shared-feature/components/select/select-base';

@Component({
  selector: 'app-paymentref-select',
  templateUrl: './paymentref-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PaymentRefSelectComponent),
      multi: true
    }
  ]
})
export class PaymentRefSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  getUrl(searchValue: string): string {
    let filter = `referenceNo ne null and referenceNo ne ''`;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter += ` and (contains(docCode, '${encodeURIComponent(
        searchStr
      )}') or contains(referenceNo,'${encodeURIComponent(searchStr)}'))`;
    }
    let url = `api/payments/ReferenceNoLookup?$top=20&$skip=0&$orderby=referenceNo asc`;
    if (filter) url += `&$filter=${filter}`;
    return url;
  }
}
